type Props = {
  id: string;
  index: number;
  fillPercentage: number;
};

export default function Star({ id, index, fillPercentage }: Props) {
  return (
    <svg
      key={index}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      viewBox="0 0 20 21"
    >
      <defs>
        <linearGradient id={`starRating-${id}-${index}`}>
          <stop offset={`${fillPercentage}%`} stopColor="#F2AE40" />
          <stop offset={`${fillPercentage}%`} stopColor="#E5E5E5" />
        </linearGradient>
      </defs>
      <path
        d="M18.75 8.19221L12.5925 7.45272L9.99671 1.75L7.40096 7.45272L1.25 8.19221L5.7975 12.4626L4.59491 18.625L9.99671 15.5538L15.4051 18.625L14.2025 12.4626L18.75 8.19221Z"
        fill={`url(#starRating-${id}-${index})`}
      />
    </svg>
  );
}
